import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FaDraftingCompass } from 'react-icons/fa'; 
import './ConsultantsSection.css';
import imageBlueprint from "../../../assets/images/ImgConsultantsTable1.jpg"; 

const ConsultantsSection = () => {
    const navigate = useNavigate();
    
    const handleFindConsultants = () => {
        navigate("/"); // Navigates to the main landing page (root path)
        window.scrollTo(0, 0); // Scrolls the window to the very top
    };

    return (
        <section className="cs-section">
            <div className="cs-container">
                <div className="cs-wrapper">
                    
                    {/* Left Side: Content */}
                    <div className="cs-content">
                        
                        {/* Header Icon */}
                        <div className="cs-icon-circle">
                            <FaDraftingCompass />
                        </div>

                        <h2 className="cs-title">
                            <span className="cs-title-dark">BEFORE THE FIRST</span>
                            <span className="cs-title-gold">BRICK IS LAID</span>
                        </h2>

                        <p className="cs-subtitle">
                            A dream home isn't built on hope; it's built on plans. Connect with the essential consultants 
                            who ensure your project is legal, safe, and built to last. Don't start digging until you've finished planning.
                        </p>

                        <button 
                            className="cs-btn"
                            onClick={handleFindConsultants}
                        >
                            Find Consultants & Designers
                        </button>
                    </div>

                    {/* Right Side: Image */}
                    <div className="cs-image-container">
                        <div className="cs-image-wrapper">
                            <img src={imageBlueprint} alt="Architectural Blueprint Meeting" className="cs-image" />
                        </div>
                    </div>

                </div>
            </div>
        </section>
    );
};

export default ConsultantsSection;